import { useEffect } from 'react';

import { KakaoPixel } from '../../common/KakaoPixel';
import { usePathnameMethod } from '../usePathnameMethod';

const useKakaoPixelPageView = () => {
  const { pathname } = usePathnameMethod();

  useEffect(() => {
    KakaoPixel.pageView();
  }, [pathname]);
};

export default useKakaoPixelPageView;
